// removed by extract-text-webpack-plugin
module.exports = {"unitLabel":"Measurement-style__unitLabel__35708ab0","divider":"Measurement-style__divider__35708ab0"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Measurement/Measurement-style.scss
// module id = 1887
// module chunks = 7 16